import { useTranslation } from 'react-i18next'
import CreateIcon from '@material-ui/icons/Create'
import bxPhone from '@iconify-icons/bx/bx-phone'
import bxAt from '@iconify-icons/bx/bx-at'
import { Icon } from '@iconify/react'
import { IconButtonProps } from '@material-ui/core'
import {
  ContactWrapper,
  HeaderSection,
  EditButton,
  Title,
} from './ContractorContact.style'
import { ContractorContact } from 'shared/types/contractors'
import Contact from './Contact'
import { useCountryPrefix } from 'shared/hooks'

const ID_PREFIX = 'contractor-contact'

interface ContractorInfoProps extends ContractorContact {
  handleSwitch: (contact: ContractorContact) => void
  isLoading?: boolean
  isTheLastActiveContact?: boolean
  contractorName: string
  editButtonProps?: Partial<IconButtonProps>
  editContactDialog?: {
    dialog: JSX.Element
    onClickOpen: () => void
  }
}

const ContactInfo = ({
  id,
  name,
  emailAddress,
  phoneNumber,
  countryId,
  handleSwitch,
  isEmailAddressActive,
  isPhoneNumberActive,
  isTheLastActiveContact,
  contractorName,
  editContactDialog,
  editButtonProps,
  isDefault,
  isLoading,
}: ContractorInfoProps) => {
  const { t } = useTranslation()
  const prefix = useCountryPrefix(countryId)

  const contactInfo = {
    id,
    name,
    emailAddress,
    phoneNumber,
    isPhoneNumberActive,
    isEmailAddressActive,
    countryId,
    isDefault,
  }

  const handleTogglePhoneNumber = async () =>
    handleSwitch({
      ...contactInfo,
      isPhoneNumberActive: !isPhoneNumberActive,
    })

  const handleToggleEmailAddress = async () =>
    handleSwitch({
      ...contactInfo,
      isEmailAddressActive: !isEmailAddressActive,
    })

  return (
    <ContactWrapper>
      <HeaderSection>
        <Title variant="h6">{isDefault ? t('defaultContact') : name}</Title>
        {editContactDialog && (
          <EditButton
            onClick={editContactDialog.onClickOpen}
            {...editButtonProps}
          >
            <CreateIcon />
          </EditButton>
        )}
      </HeaderSection>
      <Contact
        icon={<Icon icon={bxPhone} />}
        title={t('phoneNumber')}
        value={phoneNumber ? `${prefix} ${phoneNumber}` : null}
        isActive={isPhoneNumberActive}
        onSwitch={handleTogglePhoneNumber}
        isTheLastActiveContact={isTheLastActiveContact}
        contractorName={contractorName}
        id={`${ID_PREFIX}-phone-number`}
        isLoading={isLoading}
      />
      <Contact
        icon={<Icon icon={bxAt} />}
        title={t('emailAddress')}
        value={emailAddress}
        isActive={isEmailAddressActive}
        onSwitch={handleToggleEmailAddress}
        isTheLastActiveContact={isTheLastActiveContact}
        contractorName={contractorName}
        id={`${ID_PREFIX}-email-address`}
        isLoading={isLoading}
      />
      {editContactDialog?.dialog}
    </ContactWrapper>
  )
}

export default ContactInfo
